import { ComplexParamsBundle } from '../../../../types';
import './index.css';

interface Props {
  complexParamsBundle: ComplexParamsBundle;
  isFirst: boolean;
}

const ComplexParamsBundleComponent = (props: Props) => {
  const { complexParamsBundle, isFirst } = props;

  return (
    <div
      className="complex-params-bundle-root"
      style={isFirst ? { marginTop: 0 } : {}}
    >
      {!isFirst && <div className="complex-params-bundle-top-connector"></div>}
      <div className="complex-params-bundle-container">
        {/** Circle */}
        <div className="complex-params-bundle-circle">
          <span className="complex-params-bundle-circle-text">CP</span>
          <div className="complex-params-bundle-bottom-connector"></div>
        </div>
        {/** Connector  */}
        <div className="complex-params-bundle-connector"></div>
        {/** Content */}
        <div className="complex-params-bundle-content">
          {/** Left column */}
          <div className="complex-params-bundle-content-left">
            <span className="complex-params-bundle-content-label">
              Complex Params
            </span>
            {/** Cbrt */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                Cbrt:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.cbrt}
              </span>
            </div>
            {/** ShorterT Interval */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                ShorterT Interval:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.complexParams.shorterTimeFrameInterval}
              </span>
            </div>
          </div>
          {/** Right column */}
          <div className="complex-params-bundle-content-right">
            <span className="complex-params-bundle-content-label">
              TimeFrames
            </span>
            {/** Higher TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                HigherT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.higher}
              </span>
            </div>
            {/** Shorter TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                ShorterT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.shorter}
              </span>
            </div>
            {/** Multi TimeFrame */}
            <div className="complex-params-bundle-content-item">
              <span className="complex-params-bundle-content-item-label">
                MultiT:
              </span>
              <span className="complex-params-bundle-content-item-value">
                {complexParamsBundle.timeFrames.multiOrder}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ComplexParamsBundleComponent;
